import React from "react";

const HeroBackground: React.FC = () => {
  return (
    <div className="absolute inset-0">
      <img
        className="h-full w-full object-cover"
        src="/intro-bg.jpg"
        alt="Hero background"
      />
    </div>
  );
};

export default HeroBackground;
